<template>
  <div class="notification-list-container d-flex flex-column h-100 bg-white shadow-sm rounded overflow-hidden">
    <div class="list-header p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0 font-weight-bold text-dark">
        <i class="fas fa-bell mr-2 text-primary"></i>
        Thông báo hệ thống
      </h3>
      <button 
        v-if="hasUnread"
        class="btn btn-sm btn-outline-primary" 
        @click="$emit('mark-all-read')"
      >
        Đánh dấu đã đọc tất cả
      </button>
    </div>

    <!-- Filter Component -->
    <notification-filter v-model="filters" />

    <!-- List Body -->
    <div class="list-body flex-grow-1 overflow-auto bg-light" style="max-height: 70vh;">
      <div v-if="filteredNotifications.length === 0" class="empty-state text-center py-5">
        <div class="empty-icon text-muted mb-3">
          <i class="fas fa-bell-slash fa-3x opacity-2"></i>
        </div>
        <p class="text-muted">Không có thông báo nào phù hợp.</p>
      </div>
      
      <div v-else>
        <notification-item 
          v-for="noti in filteredNotifications" 
          :key="noti.id" 
          :notification="noti"
          @click="handleNotiClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NotificationItem from './NotificationItem.vue';
import NotificationFilter from './NotificationFilter.vue';

export default {
  name: 'NotificationList',
  components: {
    NotificationItem,
    NotificationFilter
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filters: {
        status: 'all', // all | unread
        type: 'all',   // order | inventory | finance | customer | user | system
        level: 'all'   // info | warning | danger
      }
    }
  },
  computed: {
    filteredNotifications() {
      return this.notifications.filter(noti => {
        // Status filter
        if (this.filters.status === 'unread' && noti.read) return false;
        
        // Type filter
        if (this.filters.type !== 'all' && noti.type !== this.filters.type) return false;
        
        // Level filter
        if (this.filters.level !== 'all' && noti.level !== this.filters.level) return false;
        
        return true;
      });
    },
    hasUnread() {
      return this.notifications.some(n => !n.read);
    }
  },
  methods: {
    handleNotiClick(noti) {
      if (!noti.read) {
        this.$emit('mark-read', noti.id);
      }
      
      // Auto-navigation based on relatedId and type
      if (noti.relatedId) {
        this.navigateToRelated(noti);
      }
    },
    navigateToRelated(noti) {
      const routes = {
        'order': 'orderhistory',
        'inventory': 'productlist',
        'finance': 'debt',
        'customer': 'customer',
        'user': 'user',
        'system': 'settings'
      };
      
      const targetRoute = routes[noti.type];
      if (targetRoute) {
        // Here we just navigate. In a real app we might pass the ID to search/highlight
        if (this.$route.name !== targetRoute) {
          this.$router.push({ name: targetRoute });
        }
      }
    }
  }
}
</script>

